export default "__VITE_ASSET__AyKC4$By__"